import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, tempSignupData, hasCompletedOnboarding } =
    useSelector((state) => state.auth);

  const location = useLocation();
  const isOnboardingRoute = location.pathname.startsWith('/onboarding');

  if (!isAuthenticated) {
    if (isOnboardingRoute) {
      if (!tempSignupData) {
        return <Navigate to="/signup" replace />;
      }

      return children;
    }

    const isManualLogout = sessionStorage.getItem('manualLogout') === 'true';

    if (isManualLogout) {
      sessionStorage.removeItem('manualLogout');
      return <Navigate to="/login" replace />;
    }

    const currentUrl = location.pathname + location.search;

    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(currentUrl)}`}
        replace
      />
    );
  }

  if (isOnboardingRoute && hasCompletedOnboarding) {
    return <Navigate to="/app/chat" replace />;
  }

  if (!isOnboardingRoute && !hasCompletedOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
